import React, { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import hljs from 'highlight.js';
import 'highlight.js/styles/base16/onedark.css';

const Moduli = () => {

	useEffect(() => {
		hljs.highlightAll();
	}, []);
	
const codice1 = `exports.somma=(a,b)=>{
    return(a+b)
}

exports.differenza=(a,b)=>{
    return(a-b)
}`;

const codice2 = `let http=require("http")

//Import del mio modulo
let pippo=require("./modulo")

http.createServer((req,res)=>{
    res.end(pippo.somma(5,7).toString()) //.toString() perchè la end vuole una stringa
}).listen("3000")`;

const codice3 = `npm init`;

const codice4 = `export const somma=(a,b)=>{
    return(a+b)
}

export const differenza=(a,b)=>{
    return(a-b)
}`;

const codice5 = `import http from "http"
import {differenza,somma} from "./modulo.js"

http.createServer((req,res)=>{
    res.end(somma(5,7).toString())
}).listen("3000")`;

const codice6 = `{
    "name": "nome_progetto",
    "version": "1.0.0",
    "description": "",
    "type": "module",
    "main": "server.js",
    "scripts": {
        "test": "echo \"Error: no test specified\" && exit 1",
        "start": "node server.js"
    },
    "author": "",
    "license": "ISC"
}`;

const codice7 = `"type": "module",
"main": "server.js",`;

const codice8 = `node server.js`;

  return (
    <div className="container-fluid">
    	<div className="div-intro">
			<div data-aos="fade-right">
			<h1>I moduli</h1>
			<hr className="underline" data-aos="fade-right"/>
			</div>
			<br/>
			<div data-aos="fade-right">
			<h4>Cosa sono?</h4>
			<div id="commonjs"></div>
			<p>
			In Node.js, i <strong>moduli</strong> sono file o directory che contengono un insieme di funzionalità riutilizzabili. L'obiettivo principale dei moduli è organizzare il codice in modo modulare, rendendo più facile la gestione delle dipendenze e la riutilizzabilità del codice. Esistono vari tipi di sistema di moduli, tra cui CommonJS e ES modules: essi servono per importare ed esportare moduli, con alcune differenze durante l'utilizzo.</p>
			</div>
			<br/><br/>
			<br/>
			<div data-aos="fade-right">
			<h1>CommonJS</h1>
			<hr className="underline" data-aos="fade-right"/>
			</div>
<div data-aos="fade-right">
<p><strong>CommonJS</strong> è una specifica che definisce un sistema standard per organizzare e strutturare codice JavaScript al di fuori dei browser web. E' uno standard di Node.js e utilizza require. Require è sincrono (<i>blocca l'esecuzione del codice</i>) e importa tutto il modulo: non c'è infatti la possibilità di fare la destrutturazione come con import, che vedremo successivamente.</p>
</div>
<br/><br/>
<div data-aos="fade-right">
<h4>Progetto CommonJS (<a href="Progetto_4_CommonJS.zip" target="_blank" download>scarica qui <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-cloud-arrow-down-fill" viewBox="0 0 16 16">
  <path d="M8 2a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13h8.906C14.502 13 16 11.57 16 9.773c0-1.636-1.242-2.969-2.834-3.194C12.923 3.999 10.69 2 8 2m2.354 6.854-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 9.293V5.5a.5.5 0 0 1 1 0v3.793l1.146-1.147a.5.5 0 0 1 .708.708"/>
</svg></a>)</h4>
<p>Ecco un progetto contentente un esempio di utilizzo di CommonJS:</p>
</div>
<div data-aos="zoom-in">
<i>modulo.js</i>
<pre className="outside-code-toolbar">
<code className="language-javascript inside-code-toolbar">
{codice1}
</code></pre>
</div>
<div data-aos="zoom-in">
<i>server.js</i>
<div id="esmodules"></div>
<pre className="outside-code-toolbar">
<code className="language-javascript inside-code-toolbar">
{codice2}
</code></pre>
</div>
<br/><br/>
<div data-aos="fade-right">
<h1>ES modules</h1>
<hr className="underline" data-aos="fade-right"/>
</div>
<div data-aos="fade-right">
<p>
<strong>ES modules</strong> e leggermente diverso da CommonJS. Esso infatti è uno standard di JavaScript e utilizza import. Import è asincrono (<i>non blocca l'esecuzione del codice</i>) e permette di importare solamente ciò che serve all'interno del nostro progetto grazie alla destrutturazione. Inoltre, usando ES modules, nel nostro progetto deve essere presente il file package.json, che contiene tutti i moduli ed è fondamentale per il funzionamento del progetto. Si deve creare all'interno della cartella con il seguente comando:</p>
</div>
<pre className="outside-code-toolbar" data-aos="zoom-in">
<code className="language-javascript inside-code-toolbar">
{codice3}
</code></pre><br/>
<p data-aos="fade-right">E' necessario inoltre aggiungere questi due campi nel package.json:</p>
<pre className="outside-code-toolbar" data-aos="zoom-in">
<code className="language-json inside-code-toolbar">
{codice7}
</code></pre><br/>
<p data-aos="fade-right">Il comando per avviare il progetto è il seguente:</p>
<pre className="outside-code-toolbar" data-aos="zoom-in">
<code className="language-javascript inside-code-toolbar">
{codice8}
</code></pre>
<br/>
<div data-aos="fade-right">
<h4>Progetto ES modules (<a href="Progetto_5_ESmodules.zip" target="_blank" download>scarica qui <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-cloud-arrow-down-fill" viewBox="0 0 16 16">
  <path d="M8 2a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13h8.906C14.502 13 16 11.57 16 9.773c0-1.636-1.242-2.969-2.834-3.194C12.923 3.999 10.69 2 8 2m2.354 6.854-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 9.293V5.5a.5.5 0 0 1 1 0v3.793l1.146-1.147a.5.5 0 0 1 .708.708"/>
</svg></a>)</h4>
<p>Ecco un progetto contentente un esempio di utilizzo di ES modules:</p>
</div>
<div data-aos="zoom-in">
<i>modulo.js</i>
<pre className="outside-code-toolbar">
<code className="language-javascript inside-code-toolbar">
{codice4}
</code></pre>
</div>
<div data-aos="zoom-in">
<i>server.js</i>
<pre className="outside-code-toolbar">
<code className="language-javascript inside-code-toolbar">
{codice5}
</code></pre>
</div>
<div data-aos="zoom-in">
<i>package.json</i>
<pre className="outside-code-toolbar">
<code className="language-json inside-code-toolbar">
{codice6}
</code></pre>
</div>
		</div>
    </div>
  );
};

export default Moduli;
